import { journeyProduct } from "./metaData";

export const getProductEnum = ctx => {
  let product: string | null = null;

  const isNewBike = ctx?.query?.flow === "new";
  const isBikeRenewal = ctx?.query?.product === "bike";

  if (ctx?.req?.url) {
    journeyProduct.forEach(each => {
      const isValidJourney = !!ctx?.req?.url?.includes(each.url);
      if (isValidJourney && !isNewBike) {
        product = each.journey;
      }
    });
  }

  if (ctx?.req?.url?.includes("/bike-journey/") && isNewBike) {
    product = "newBike";
  }

  if (ctx?.req?.url?.includes("/renew-policy") && isBikeRenewal) {
    product = "renewBike";
  }

  if (ctx?.req?.url?.includes("/widgets")) {
    if (ctx?.req?.url?.includes("/bike")) {
      product = "freshBike";
    } else if (ctx?.req?.url?.includes("/car")) {
      product = "freshCar";
    }
  }

  return product;
};
